<template>
    <div class="d-flex justify-content-between align-items-center mb-3 mt-2 me-4 ms-4">
        <!-- Botón para cambiar entre vista de tarjetas y lista -->
        <div 
            class="view-toggle-icon"
            :title="viewAsCard ? 'Cambiar a vista de lista' : 'Cambiar a vista de tarjetas'"
            @click="toggleView"
        >
            <i :class="viewAsCard ? 'fa-solid fa-list' : 'fa-solid fa-grid-2'"></i>
        </div>
        
        <!-- Campo de búsqueda -->
        <input
v-model="search" placeholder="Buscar... por nombre completo, edad o rango de edad o género"
            class="form-control w-50" @input="applyFilter" />

        <div class="col-sm-4">
            <select
id="choices-category-filter" v-model="selectedFilter" class="form-control"
                name="choices-category-filter" @change="applyFilter">
                <option value="updated_at" selected>Fecha de modificación</option>
                <option value="created_at">Fecha de creación</option>
                <option value="first_name">Nombres</option>
                <option value="last_name">Apellidos</option>
            </select>
        </div>

        <!-- Select para número de elementos por página -->
        <select
v-model.number="itemsPerPage" class="form-select w-auto px-2" style="width: 60px !important;"
            @change="updateItemsPerPage">
            <option value="6">6</option>
            <option value="9">9</option>
            <option value="30">30</option>
            <option value="50">50</option>
        </select>
    </div>
</template>

<script setup>
import { ref, onMounted, defineEmits } from 'vue';

// Define los eventos emitidos por el componente
const emit = defineEmits(['applyFilter', 'updateItemsPerPage', 'updateViewAsCard']);

// Variables reactivas para el estado del componente
const viewAsCard = ref(true);
const search = ref('');
const selectedFilter = ref('updated_at');
const itemsPerPage = ref(9);

// Función para aplicar el filtro de búsqueda y categoría
const applyFilter = () => {
    emit('applyFilter', { search: search.value, selectedFilter: selectedFilter.value });
};

// Función para actualizar el número de elementos por página
const updateItemsPerPage = () => {
    emit('updateItemsPerPage', itemsPerPage.value);
};

// Función para cambiar entre vista de tabla y tarjeta (toggle)
const toggleView = () => {
    viewAsCard.value = !viewAsCard.value;
    emit('updateViewAsCard', viewAsCard.value);
};

// Emite el valor inicial de `viewAsCard` cuando se monta el componente
onMounted(() => {
    emit('updateViewAsCard', viewAsCard.value);
});
</script>

<style scoped>
.view-toggle-icon {
    position: relative;
    cursor: pointer;
    color: #8392ab;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
}

.view-toggle-icon i {
    font-size: 1.3rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.view-toggle-icon:hover {
    color: #5e72e4;
    background: rgba(94, 114, 228, 0.1);
}

.view-toggle-icon:hover i {
    transform: scale(1.1) rotate(-5deg);
}

.view-toggle-icon:active {
    color: #324cdd;
    background: rgba(94, 114, 228, 0.2);
    transform: scale(0.95);
}

.view-toggle-icon:active i {
    transform: scale(1) rotate(0deg);
}

/* Efecto de pulso sutil */
.view-toggle-icon::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background: rgba(94, 114, 228, 0.15);
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0;
}

.view-toggle-icon:hover::before {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 1;
}
</style>
